<template>
  <div class="m-site-header" :class="{ [`m-site-header--${brand}`]: brand }">
    <div class="m-site-header__logo">
      <slot name="logo" />
    </div>
    <nav class="m-site-header__nav">
      <slot name="nav" />
    </nav>
  </div>
</template>

<script lang="ts">
import brands from '../../../constants/brands'

export default {
  name: 'MSiteHeaderLayout',
  props: {
    brand: {
      type: String,
      required: false,
      default: 'manypets',
      validator: (prop: string) => brands.includes(prop),
    },
  },
}
</script>

<style lang="scss">
.m-site-header {
  align-items: center;
  display: flex;
  width: 100%;

  &__logo {
    margin-right: var(--spacing-24);
    width: 150px;
  }

  &__nav {
    align-items: center;
    display: flex;
    flex: 1 1 auto;
    height: 100%;
    justify-content: flex-end;
  }
}
</style>
